// Import model
import { FilterProjectSelectionRequest } from '../models/FilterProjectSelectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ProjectSelectionCondition } from '../models/ProjectSelectionCondition';
import { ProjectSelectionFields } from '../models/ProjectSelectionFields';
import { ProjectSelectionIndexedFields } from '../models/ProjectSelectionIndexedFields';

// Import dependency serializers (for complex types)
import { ProjectSelectionConditionSerializer } from './ProjectSelectionConditionSerializer';
import { ProjectSelectionFieldsSerializer } from './ProjectSelectionFieldsSerializer';
import { ProjectSelectionIndexedFieldsSerializer } from './ProjectSelectionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterProjectSelectionRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterProjectSelectionRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterProjectSelectionRequest instance
   */
  static deserialize(json: string): FilterProjectSelectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterProjectSelectionRequest instance
   */
  static fromObject(obj: any): FilterProjectSelectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterProjectSelectionRequest');
    }


    const instance: FilterProjectSelectionRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ProjectSelectionIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ProjectSelectionFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ProjectSelectionConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterProjectSelectionRequest instances
   */
  static deserializeArray(json: string): FilterProjectSelectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterProjectSelectionRequest instance to a JSON string
   */
  static serialize(instance: FilterProjectSelectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterProjectSelectionRequest instance to a plain object
   */
  static toObject(instance: FilterProjectSelectionRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ProjectSelectionConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterProjectSelectionRequest instances to a JSON string
   */
  static serializeArray(instances: FilterProjectSelectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
